// src/components/MultiStepForm/AdditionalVehicleForm.js
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import { decodeVin, extractVehicleInfo } from '../../services/vehicleService';

const AdditionalVehicleForm = ({ index, onRemove }) => {
  const { setValue, watch } = useFormContext();
  const prefix = `additional_vehicles[${index}]`;
  const loanPrefix = `additional_loans[${index}]`;

  const vinValue = watch(`${prefix}.vin`);

  // Auto-fill make, model, and year when VIN is 17 characters
  useEffect(() => {
    if (vinValue && vinValue.length === 17) {
      decodeVin(vinValue).then((results) => {
        const vehicle = extractVehicleInfo(results);
        setValue(`${prefix}.make`, vehicle.make || '');
        setValue(`${prefix}.model`, vehicle.model || '');
        setValue(`${prefix}.model_year`, vehicle.model_year || '');
      });
    }
  }, [vinValue, prefix, setValue]);

  return (
    <div className="border p-3 rounded mb-4 bg-light">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">Additional Vehicle #{index + 2}</h5>
        <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => onRemove(index)}>
          Remove Vehicle
        </button>
      </div>

      {/* Vehicle Info */}
      <div className="row">
        <FormField name={`${prefix}.vin`} label="VIN Number" type="text" required colSpan={6} />
        <FormField name={`${prefix}.make`} label="Make" type="text" required colSpan={6} />
        <FormField name={`${prefix}.model`} label="Model" type="text" required colSpan={4} />
        <FormField name={`${prefix}.model_year`} label="Year" type="number" required colSpan={4} />
        <FormField name={`${prefix}.mileage`} label="Mileage" type="number" required colSpan={4} />
      </div>

      {/* Loan Info */}
      <div className="row mt-3">
        <FormField name={`${loanPrefix}.current_monthly_payment`} label="Monthly Loan Payment" type="text" required colSpan={6} />
        <FormField name={`${loanPrefix}.current_payoff`} label="Remaining Loan" type="text" required colSpan={6} />
        <FormField name={`${loanPrefix}.next_payment_date`} label="Next Payment Date" type="date" required colSpan={6} />
        <FormField name={`${loanPrefix}.lien_holder`} label="Current Lender" type="text" required colSpan={6} />
      </div>
    </div>
  );
};

export default AdditionalVehicleForm;
